<script setup lang="ts">
import FormEspacoEvento from '../components/form-espacoevento.vue'
import { useEspacoEventoStore } from '../store/useEspacoEventoStore'

definePage({
  meta: {
    navActiveLink: 'admin-espaco-evento',
    action: 'edit',
    subject: 'espaco-evento',
  },
})

const store = useEspacoEventoStore()
const router = useRouter()

const {
  fetchItem,
} = store

fetchItem(router.currentRoute.value.params.id)
</script>

<template>
  <FormEspacoEvento is-editing />
</template>
